import { render, staticRenderFns } from "./To-dos.vue?vue&type=template&id=e1d8b920&scoped=true&"
import script from "./To-dos.vue?vue&type=script&lang=js&"
export * from "./To-dos.vue?vue&type=script&lang=js&"
import style0 from "./To-dos.vue?vue&type=style&index=0&id=e1d8b920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d8b920",
  null
  
)

export default component.exports